import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Home, MessageSquare, Wrench, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SEO } from "@/components/SEO";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-[80vh] items-center justify-center px-4">
      <SEO
        title="Page Not Found (404) — GenieBot Pro"
        description="This GenieBot Pro page doesn't exist or has moved. Jump back to the dashboard, AI chat, or the full library of 40+ free AI tools."
        path={location.pathname}
        noindex
      />
      <div className="max-w-md w-full text-center space-y-6 animate-fade-in">
        <div className="relative">
          <div className="absolute inset-0 bg-primary/10 rounded-full blur-3xl" />
          <h1 className="relative text-8xl font-black text-primary/80">404</h1>
        </div>
        <div className="space-y-2">
          <h2 className="text-xl font-semibold text-foreground">Page not found</h2>
          <p className="text-muted-foreground text-sm">
            The page <code className="bg-muted px-1.5 py-0.5 rounded text-xs">{location.pathname}</code> doesn't exist.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
          <Button asChild variant="default" className="gap-2">
            <Link to="/dashboard"><Home className="h-4 w-4" /> Dashboard</Link>
          </Button>
          <Button asChild variant="outline" className="gap-2">
            <Link to="/chat"><MessageSquare className="h-4 w-4" /> Chat</Link>
          </Button>
          <Button asChild variant="ghost" className="gap-2">
            <Link to="/tools"><Wrench className="h-4 w-4" /> Tools</Link>
          </Button>
        </div>
        <Button variant="link" className="gap-1 text-xs" onClick={() => window.history.back()}>
          <ArrowLeft className="h-3 w-3" /> Go back
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
